webpackJsonp([254],{

/***/ 1312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersDetail_vue__ = __webpack_require__(3083);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ade4076_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersDetail_vue__ = __webpack_require__(5779);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ade4076_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_users_users_api_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    /**
     * 判断是否为图片文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isImageFile: function isImageFile(url) {
      if (!url) return false;

      // 最后通过文件扩展名判断
      try {
        var path = new URL(url).pathname;
        var ext = path.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff', 'tif'].includes(ext)) {
          console.log(url + ' match img ext');
          return true;
        }
      } catch (error) {
        // do nothing
        console.log(error);
      }
      return false;
    },

    /**
     * 判断是否为视频文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isVideoFile: function isVideoFile(url) {
      if (!url) return false;

      // 通过 URL 中的存储桶关键字快速判断
      var videoBuckets = ['sjrawvideopub.', 'sjrawvideopubdev.', 'sjvideopub.', 'sjvideopubdev.', 'sjvideopubcnv.', 'sjvideopubcnvdev.'];
      if (videoBuckets.some(function (bucket) {
        return url.includes(bucket);
      })) {
        console.log(url + ' match video bucket name');
        return true;
      }
      // 最后通过文件扩展名判断
      try {
        var path = new URL(url).pathname;
        var ext = path.split('.').pop().toLowerCase();
        if (['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'mpeg', 'mpg', 'm3u8', 'mpd'].includes(ext)) {
          console.log(url + ' match video ext');
          return true;
        }
      } catch (error) {
        // do nothing
      }
      return false;
    },
    onChangeUserWorkInfoEvidence: function onChangeUserWorkInfoEvidence(file) {
      var fileType = file.raw.type;
      var fileSizeMB = file.raw.size / 1024 / 1024;
      var isImage = fileType === 'image/jpeg' || fileType === 'image/png';
      var isVideo = fileType === 'video/mp4';
      if (!isImage && !isVideo) {
        this.$message.error('请上传jpg/png图片或mp4视频!');
        return false;
      }
      if (isImage && fileSizeMB > 5) {
        this.$message.error('图片大小不能超过5MB!');
        return false;
      }
      if (isVideo && fileSizeMB > 200) {
        this.$message.error('视频大小不能超过200MB!');
        return false;
      }
      return this.doAdminDirectUploadFile(file.raw);
    },
    doAdminDirectUploadFile: function doAdminDirectUploadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, res, uploadUrl, contentType, uploadRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                params = {
                  file_name: file.name,
                  ext: file.name.split('.').pop().toLowerCase(),
                  content_type: file.type || 'application/octet-stream'
                };
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__views_users_users_api_js__["adminDirectUploadFilesApi"])(params);

              case 4:
                res = _context.sent;

                if (!(res.data.ret === 0)) {
                  _context.next = 17;
                  break;
                }

                uploadUrl = res.data.detail.signedUrl;
                contentType = res.data.detail.content_type;
                _context.next = 10;
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': contentType }),
                  body: file
                });

              case 10:
                uploadRes = _context.sent;

                if (uploadRes.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error('\u4E0A\u4F20\u5931\u8D25\uFF0C\u539F\u56E0: ' + uploadRes.status);

              case 13:
                _this.$message({ message: '上传成功', type: 'success' });
                return _context.abrupt('return', res.data.detail.url);

              case 17:
                _this.$message.error('上传失败，原因: ' + res.data.msg);
                return _context.abrupt('return', false);

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](0);

                _this.$message.error('上传失败，原因: ' + _context.t0.message);
                return _context.abrupt('return', false);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 21]]);
      }))();
    },

    // 附件上传,标准化字段结构
    formatStandardFile: function formatStandardFile(file, loginUser) {
      return {
        submit_admin_id: loginUser.id,
        submit_admin_name: loginUser.name,
        submit_at: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        name: file.name,
        size: file.size,
        url: file.url,
        uid: file.uid
      };
    }
  }
});

/***/ }),

/***/ 1523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoPlayerDialog',
  props: {
    // 是否显示弹窗（支持 .sync）
    visible: {
      type: Boolean,
      default: false
    },
    // 视频 URL 列表
    videos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 打开时默认播放的视频索引
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      currentUrl: '',
      scale: 1,
      rotation: 0,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      instantReset: false,
      dragStartX: 0,
      dragStartY: 0,
      startTranslateX: 0,
      startTranslateY: 0,
      isPlaying: false,
      videoCurrentTime: 0,
      videoDuration: 0
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.currentIndex = Math.min(Math.max(this.index, 0), Math.max(this.videos.length - 1, 0));
        this.currentUrl = this.videos[this.currentIndex] || '';
        this.resetVideoState();
        this.$nextTick(function () {
          var wrapper = _this.$refs.videoDialogWrapper;
          wrapper && wrapper.focus();
        });
      }
    }
  },
  methods: {
    /**
     * 关闭弹窗时的清理
     */
    handleClose: function handleClose() {
      this.currentUrl = '';
      this.resetVideoState();
    },

    /**
     * ESC 关闭弹窗
     */
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },

    /**
     * 重置视频播放状态
     */
    resetVideoState: function resetVideoState() {
      this.scale = 1;
      this.rotation = 0;
      this.translateX = 0;
      this.translateY = 0;
      this.isDragging = false;
      this.isPlaying = false;
      this.videoCurrentTime = 0;
      this.videoDuration = 0;
    },

    /**
     * @param {string} url 视频地址
     */
    goToVideo: function goToVideo(url) {
      var _this2 = this;

      this.instantReset = true;
      this.currentUrl = url;
      this.resetVideoState();
      this.$nextTick(function () {
        _this2.instantReset = false;
      });
    },

    /**
     * 切换到上一个视频
     */
    prevVideo: function prevVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 切换到下一个视频
     */
    nextVideo: function nextVideo() {
      if (this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 点击缩略图直接播放指定视频
     * @param {number} i 视频索引
     */
    playVideoByIndex: function playVideoByIndex(i) {
      if (i === this.currentIndex) return;
      if (i < 0 || i >= this.videos.length) return;
      this.currentIndex = i;
      this.goToVideo(this.videos[i] || '');
    },

    /**
     * 视频滚轮缩放
     * @param {WheelEvent} e
     */
    onVideoWheel: function onVideoWheel(e) {
      var delta = e.deltaY > 0 ? -0.1 : 0.1;
      var newScale = this.scale + delta;
      newScale = Math.max(0.5, Math.min(5, newScale));
      this.scale = parseFloat(newScale.toFixed(2));
    },
    rotateVideo: function rotateVideo() {
      this.rotation += 90;
    },

    /**
     * 开始拖拽视频
     * @param {MouseEvent} e
     */
    onDragStart: function onDragStart(e) {
      if (e.button !== 0) return;
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.startTranslateX = this.translateX;
      this.startTranslateY = this.translateY;
    },

    /**
     * 拖拽中
     * @param {MouseEvent} e
     */
    onDragMove: function onDragMove(e) {
      if (!this.isDragging) return;
      this.translateX = this.startTranslateX + (e.clientX - this.dragStartX) / this.scale;
      this.translateY = this.startTranslateY + (e.clientY - this.dragStartY) / this.scale;
    },

    /**
     * 结束拖拽
     */
    onDragEnd: function onDragEnd() {
      this.isDragging = false;
    },

    /**
     * 切换播放/暂停
     */
    togglePlay: function togglePlay() {
      var video = this.$refs.videoPlayer;
      if (!video) return;
      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },

    /**
     * 视频播放进度更新
     */
    onTimeUpdate: function onTimeUpdate() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoCurrentTime = video.currentTime;
      }
    },

    /**
     * 视频元数据加载完成
     */
    onLoadedMeta: function onLoadedMeta() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoDuration = video.duration || 0;
      }
    },

    /**
     * 视频播放结束
     */
    onVideoEnded: function onVideoEnded() {
      this.isPlaying = false;
    },

    /**
     * 点击进度条跳转
     * @param {MouseEvent} e
     */
    seekVideo: function seekVideo(e) {
      var video = this.$refs.videoPlayer;
      var track = e.currentTarget;
      if (!video || !track || !this.videoDuration) return;
      var rect = track.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      video.currentTime = ratio * this.videoDuration;
      this.videoCurrentTime = video.currentTime;
    },

    /**
     * 格式化视频时间
     * @param {number} seconds
     * @returns {string}
     */
    formatVideoTime: function formatVideoTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) return '00:00';
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
  }
});

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1599);
function injectStyle (ssrContext) {
  __webpack_require__(1597)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1597:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("073a162c", content, true, {});

/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".video-player-dialog.el-dialog{background-color:rgba(0,0,0,.5);-webkit-box-shadow:none!important;box-shadow:none!important;margin:0!important;width:100%!important;height:100vh;border-radius:0}.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent!important}.video-player-dialog .el-dialog__header{padding:0}.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color .15s;transition:background-color .15s;z-index:2050}.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,.8)}.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px}.video-player-dialog .video-dialog-wrapper{-ms-flex-align:center;-ms-flex-pack:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden}.video-player-dialog .video-dialog-content,.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-align:center;-ms-flex-pack:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent!important}.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing}.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform .1s ease-out;transition:-webkit-transform .1s ease-out;transition:transform .1s ease-out;transition:transform .1s ease-out,-webkit-transform .1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent!important}.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none}.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer}.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:hsla(0,0%,100%,.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color .3s,opacity .3s;transition:background-color .3s,opacity .3s;z-index:10}.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff}.video-player-dialog .video-nav-arrow:hover{background-color:hsla(0,0%,100%,.4)}.video-player-dialog .video-nav-arrow.disabled{opacity:.3;cursor:not-allowed}.video-player-dialog .video-nav-arrow.disabled:hover{background-color:hsla(0,0%,100%,.2)}.video-player-dialog .video-nav-prev{left:12px}.video-player-dialog .video-nav-next{right:12px}.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity .2s;transition:opacity .2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px}.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:hsla(0,0%,100%,.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden}.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px}.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none}.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums}.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right}.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px}.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.3);border-radius:3px}.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:.7;-webkit-transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,transform .2s;transition:border-color .2s,opacity .2s,transform .2s,-webkit-transform .2s}.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)}.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1}.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000}", "", {"version":3,"sources":["/workspace/src/views/user-workinfo/components/VideoPlayerDialog.vue"],"names":[],"mappings":"AACA,+BAA+B,gCAAiC,kCAAmC,0BAA2B,mBAAoB,qBAAsB,aAAa,eAAe,CACnM,AACD,sCAAsC,UAAU,YAAY,sCAAuC,CAClG,AACD,wCAAwC,SAAS,CAChD,AACD,2CAA2C,eAAe,UAAU,YAAY,WAAW,YAAY,SAAS,gCAAiC,kBAAkB,gBAAgB,yCAA0C,iCAAkC,YAAY,CAC1Q,AACD,kGAAkG,+BAAgC,CACjI,AACD,6DAA6D,kBAAkB,YAAY,UAAU,WAAW,cAAc,CAC7H,AACD,2CAAyH,sBAAsB,AAA2C,qBAAqB,AAAuB,YAAY,kBAAkB,eAAe,aAAa,eAAe,CAC9S,AACD,sFAF2C,oBAAoB,oBAAoB,aAAa,yBAAyB,AAAsB,mBAAmB,wBAAwB,AAAqB,sBAAuB,CAGrO,AADD,2CAA2C,mBAAmB,WAAW,OAAO,AAA8E,sBAAsB,AAA2C,qBAAqB,AAAuB,oBAAoB,YAAY,qBAAqB,8BAA8B,sBAAsB,sCAAuC,CAC1Z,AACD,uDAAuD,wBAAwB,eAAe,CAC7F,AACD,8CAA8C,qBAAqB,kBAAkB,kDAAmD,0CAA2C,kCAAmC,iEAAoE,uCAAuC,+BAA+B,sCAAuC,CACtY,AACD,4DAA4D,wBAAwB,eAAe,CAClG,AACD,mCAAmC,gBAAgB,eAAe,+BAA+B,WAAW,YAAY,aAAa,6BAA6B,cAAc,cAAc,CAC7L,AACD,sCAAsC,kBAAkB,QAAQ,mCAAmC,2BAA2B,WAAW,YAAY,kBAAkB,oCAAuC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,oDAAuD,4CAA+C,UAAU,CACvgB,AACD,wCAAwC,eAAe,WAAW,4BAA4B,CAC7F,AACD,4CAA4C,mCAAsC,CACjF,AACD,+CAA+C,WAAY,kBAAkB,CAC5E,AACD,qDAAqD,mCAAsC,CAC1F,AACD,qCAAqC,SAAS,CAC7C,AACD,qCAAqC,UAAU,CAC9C,AACD,4CAA4C,kBAAkB,YAAY,SAAS,mCAAmC,2BAA2B,YAAY,UAAU,0BAA2B,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,eAAe,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC/a,AACD,yDAAyD,eAAe,WAAW,eAAe,oBAAoB,cAAc,+BAAgC,uBAAwB,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,iBAAiB,CACnb,AACD,4DAA4D,mBAAmB,WAAW,OAAO,WAAW,+BAAkC,kBAAkB,eAAe,kBAAkB,eAAe,CAC/M,AACD,kEAAkE,WAAW,iBAAiB,CAC7F,AACD,2DAA2D,YAAY,mBAAmB,sBAAsB,mBAAmB,CAClI,AACD,uDAAuD,eAAe,WAAW,mBAAmB,oBAAoB,cAAc,iCAAiC,CACtK,AACD,wDAAwD,eAAe,cAAc,mBAAmB,oBAAoB,cAAc,kCAAkC,eAAe,gBAAgB,CAC1M,AACD,uCAAuC,kBAAkB,SAAS,OAAO,QAAQ,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,iBAAiB,0BAA2B,gBAAgB,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC5W,AACD,0DAA0D,UAAU,CACnE,AACD,gEAAgE,8BAAiC,iBAAiB,CACjH,AACD,yDAAyD,mBAAmB,kBAAkB,cAAc,WAAW,YAAY,kBAAkB,gBAAgB,eAAe,6BAA6B,WAAY,sEAA2E,8DAAmE,sDAA2D,2EAAkF,CACvf,AACD,+DAA+D,UAAU,mCAAmC,0BAA0B,CACrI,AACD,gEAAgE,qBAAqB,SAAS,CAC7F,AACD,6EAA6E,WAAW,YAAY,oBAAoB,iBAAiB,cAAc,qBAAqB,CAC3K","file":"VideoPlayerDialog.vue","sourcesContent":["\n.video-player-dialog.el-dialog{background-color:rgba(0,0,0,0.5);-webkit-box-shadow:none !important;box-shadow:none !important;margin:0 !important;width:100% !important;height:100vh;border-radius:0\n}\n.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent !important\n}\n.video-player-dialog .el-dialog__header{padding:0\n}\n.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,0.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color 0.15s;transition:background-color 0.15s;z-index:2050\n}\n.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,0.8)\n}\n.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px\n}\n.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden\n}\n.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent !important\n}\n.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing\n}\n.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform 0.1s ease-out;transition:-webkit-transform 0.1s ease-out;transition:transform 0.1s ease-out;transition:transform 0.1s ease-out, -webkit-transform 0.1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent !important\n}\n.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none\n}\n.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer\n}\n.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:rgba(255,255,255,0.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color 0.3s, opacity 0.3s;transition:background-color 0.3s, opacity 0.3s;z-index:10\n}\n.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff\n}\n.video-player-dialog .video-nav-arrow:hover{background-color:rgba(255,255,255,0.4)\n}\n.video-player-dialog .video-nav-arrow.disabled{opacity:0.3;cursor:not-allowed\n}\n.video-player-dialog .video-nav-arrow.disabled:hover{background-color:rgba(255,255,255,0.2)\n}\n.video-player-dialog .video-nav-prev{left:12px\n}\n.video-player-dialog .video-nav-next{right:12px\n}\n.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,0.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity 0.2s;transition:opacity 0.2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px\n}\n.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:rgba(255,255,255,0.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden\n}\n.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px\n}\n.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none\n}\n.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums\n}\n.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right\n}\n.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,0.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.3);border-radius:3px\n}\n.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:0.7;-webkit-transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s, -webkit-transform 0.2s\n}\n.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)\n}\n.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1\n}\n.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"100%","top":"0px","modal":false,"append-to-body":"","custom-class":"video-player-dialog"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('div',{ref:"videoDialogWrapper",staticClass:"video-dialog-wrapper",attrs:{"tabindex":"-1"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.togglePlay($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"r",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.rotateVideo($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeDialog($event)}],"wheel":function($event){$event.preventDefault();return _vm.onVideoWheel($event)}}},[(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-prev",class:{ disabled: _vm.currentIndex === 0 },on:{"click":_vm.prevVideo}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"video-dialog-content",class:{ 'is-dragging': _vm.isDragging },on:{"mousedown":_vm.onDragStart,"mousemove":_vm.onDragMove,"mouseup":_vm.onDragEnd,"mouseleave":_vm.onDragEnd}},[_c('div',{staticClass:"video-transform-wrapper",class:{ 'no-transition': _vm.isDragging || _vm.instantReset },style:({ transform: ("scale(" + _vm.scale + ") translate(" + _vm.translateX + "px, " + _vm.translateY + "px) rotate(" + _vm.rotation + "deg)") })},[(_vm.currentUrl)?_c('video',{ref:"videoPlayer",staticClass:"video-player",attrs:{"src":_vm.currentUrl,"autoplay":""},on:{"timeupdate":_vm.onTimeUpdate,"loadedmetadata":_vm.onLoadedMeta,"play":function($event){_vm.isPlaying = true},"pause":function($event){_vm.isPlaying = false},"ended":_vm.onVideoEnded}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"custom-video-controls"},[_c('div',{staticClass:"control-btn",attrs:{"title":"播放/暂停（按 空格 键切换）"},on:{"click":_vm.togglePlay}},[(!_vm.isPlaying)?_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6 5 L19 12 L6 19 Z"}})]):_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"3","stroke-linecap":"round"}},[_c('line',{attrs:{"x1":"7","y1":"5","x2":"7","y2":"19"}}),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":"5","x2":"17","y2":"19"}})])]),_vm._v(" "),_c('div',{staticClass:"progress-track",on:{"click":_vm.seekVideo}},[_c('div',{staticClass:"progress-fill",style:({ width: _vm.videoDuration ? (_vm.videoCurrentTime / _vm.videoDuration * 100) + '%' : '0%' })})]),_vm._v(" "),_c('span',{staticClass:"time-text"},[_vm._v(_vm._s(_vm.formatVideoTime(_vm.videoCurrentTime))+" / "+_vm._s(_vm.formatVideoTime(_vm.videoDuration)))]),_vm._v(" "),_c('div',{staticClass:"control-btn",staticStyle:{"margin-left":"0"},attrs:{"title":"向右旋转（快捷键 R）"},on:{"click":_vm.rotateVideo}},[_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"9","y":"11","width":"11","height":"11","rx":"1.2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5 14 C5 10, 8 6, 14 6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 6 L11 4 M14 6 L11 8"}})])]),_vm._v(" "),_c('span',{staticClass:"scale-text",attrs:{"title":"通过滚轮控制缩放大小"}},[_vm._v(_vm._s((_vm.scale * 100).toFixed(0))+"%")])]),_vm._v(" "),(_vm.videos.length)?_c('div',{staticClass:"video-thumbnails"},_vm._l((_vm.videos),function(url,i){return _c('div',{key:i,staticClass:"video-thumb-item",class:{ active: i === _vm.currentIndex },on:{"click":function($event){return _vm.playVideoByIndex(i)}}},[_c('video',{staticClass:"video-thumb-player",attrs:{"src":url,"preload":"metadata","muted":"","playsinline":""},domProps:{"muted":true}})])}),0):_vm._e(),_vm._v(" "),(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-next",class:{ disabled: _vm.currentIndex === _vm.videos.length - 1 },on:{"click":_vm.nextVideo}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_user_workinfo_user_workinfo_mixin_js__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_user_workinfo_components_VideoPlayerDialog_vue__ = __webpack_require__(1575);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__views_user_workinfo_user_workinfo_mixin_js__["a" /* default */]],
  components: { VideoPlayerDialog: __WEBPACK_IMPORTED_MODULE_4__views_user_workinfo_components_VideoPlayerDialog_vue__["a" /* default */] },
  data: function data() {
    return {
      id: this.$route.query.userid || 0,
      base: window._env_.VUE_APP_OLD_ADMIN_HOST,
      detailData: {
        userid: null,
        currentstatus: null,
        status: null,
        freeze_reason: null,
        freeze_reason_customize: null,
        cellphone: null,
        weixin_info: null,
        nickname: null,
        realname: null,
        tag: null,
        label_tag: null,
        teke_tag: null,
        other_tag: null,
        ability_group: null,
        level: null,
        IDcard_location: null,
        idcard_address: null,
        idcard_expired_date: null,
        idcard_expire_status_str: null,
        current_location: [],
        current_market: [],
        user_watched_market: [],
        user_watched_locations: [],
        referrercode: null,
        order_list: 3,
        archieve_tasks_list: 1,
        registertime: null,
        referrer: null,
        is_forbidden_withdraw: 0,
        believable: null,
        type: null,
        occupations: [],
        workcard_photo: [],
        workinfo_status: 0,
        belongto: '',
        business_type: 0,
        business_type_txt: '',
        work_type: 0,
        work_type_txt: '',
        know_from: '',
        last_active_tp: null,
        str_register_app_type: '',
        str_last_active_app_type: ''
      },
      freezeOptions: [{ id: 0, keyword: '待验证' }, { id: 1, keyword: '已验证' }, { id: -1, keyword: '阶段性封号' }, { id: -2, keyword: '永久性封号' }],
      table: [{
        key: 'userid',
        label: '用户ID'
      }, {
        key: 'currentstatus',
        label: '当前状态'
      }, {
        key: 'type',
        label: '用户类型'
      }, {
        key: 'status',
        label: '用户状态'
      }, {
        key: 'freeze_reason',
        label: '封号原因'
      }, {
        key: 'is_forbidden_withdraw',
        label: '禁止提现'
      }, {
        key: 'believable',
        label: '是否可信'
      }, {
        key: 'cellphone',
        label: '手机号码'
      }, {
        key: 'weixin_info',
        label: '当前绑定微信'
      }, {
        key: 'nickname',
        label: '昵称'
      }, {
        key: 'realname',
        label: '用户名称'
      }, {
        key: 'tag',
        label: '主平台标签'
      }, {
        key: 'occupations',
        label: '自选职业'
      }, {
        key: 'business_type_txt',
        label: '行业'
      }, {
        key: 'work_type_txt',
        label: '工种'
      }, {
        key: 'belongto',
        label: '厂家'
      }, {
        key: 'workcard_photo',
        label: '工作证'
      }, {
        key: 'workinfo_status',
        label: '职业信息状态'
      }, {
        key: 'label_tag',
        label: '标注标签'
      }, {
        key: 'teke_tag',
        label: 'teke标签'
      }, {
        key: 'other_tag',
        label: '其他标签'
      }, {
        key: 'ability_group',
        label: '用户能力组'
      }, {
        key: 'level',
        label: '用户等级'
      }, {
        key: 'idcard_expired_date',
        label: '身份证过期时间'
      }, {
        key: 'idcard_expire_status_str',
        label: '实名信息有效状态'
      }, {
        key: 'idcard_address',
        label: '身份证详细地址'
      }, {
        key: 'IDcard_location',
        label: '身份证所在地'
      }, {
        key: 'current_location',
        label: '当前所在地'
      }, { key: 'current_market_system', label: '最后做单门店' }, { key: 'user_watched_market', label: '关注门店' }, { key: 'user_watched_locations', label: '关注区域' }, {
        key: 'referrercode',
        label: '推荐码'
      }, {
        key: 'referrer',
        label: '推荐人手机'
      }, {
        key: 'know_from',
        label: '了解途径'
      }, {
        key: 'registertime',
        label: '注册时间'
      }, {
        key: 'str_register_app_type',
        label: '注册平台'
      }, {
        key: 'last_active_tp',
        label: '最后登录时间'
      }, {
        key: 'str_last_active_app_type',
        label: '最后登录平台'
      }, {
        key: 'order_list',
        label: '订单列表'
      }, {
        key: 'archieve_tasks_list',
        label: '归档任务列表'
      }],
      attach_file_visible: false,
      videoPreviewVisible: false,
      videoPreviewVideos: [],
      videoPreviewIndex: 0
    };
  },

  computed: Vuex.mapState({
    userOptions: function userOptions(state) {
      return state.users.userOptions;
    },
    options: function options(state) {
      return state.users.options;
    }
  }),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.id) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.setFormData(_this.id);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    ifKey: function ifKey(scope, name) {
      return scope.row.key === name;
    },
    setFormData: function setFormData(id) {
      var _this2 = this;

      request.page('getUserDetail', id).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2) {
          var data = _ref2.data;
          var key, value, businessTypeObj;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(data);

                case 1:
                  if ((_context2.t1 = _context2.t0()).done) {
                    _context2.next = 11;
                    break;
                  }

                  key = _context2.t1.value;

                  if (!_this2.detailData.hasOwnProperty(key)) {
                    _context2.next = 9;
                    break;
                  }

                  // 默认获得来源数据
                  value = data[key];

                  if (!(key === 'tag')) {
                    _context2.next = 8;
                    break;
                  }

                  _this2.setTagDetail(value);
                  return _context2.abrupt('continue', 1);

                case 8:

                  _this2.detailData[key] = value;

                case 9:
                  _context2.next = 1;
                  break;

                case 11:
                  _this2.detailData.workinfo_status = parseInt(_this2.detailData.workinfo_status);

                  _context2.next = 14;
                  return request.common('getUserLatestWorkInfoApi', { userid: id }).then(function (_ref3) {
                    var data = _ref3.data;

                    _this2.detailData.workcard_photo = _.get(data, 'workcard_photo', _this2.detailData.workcard_photo);
                    _this2.detailData.belongto = _.get(data, 'belongto', _this2.detailData.belongto);
                    _this2.detailData.work_type_txt = _.get(data, 'work_type_txt', _this2.detailData.work_type_txt);
                    _this2.detailData.business_type = _.get(data, 'business_type', _this2.detailData.business_type);
                  });

                case 14:
                  _this2.detailData.workcard_photo = _this2.detailData.workcard_photo.map(function (item) {
                    return _this2.isVideoFile(item) ? item : filter.ossFormatJpg(item);
                  });

                  businessTypeObj = _this2.userOptions.business_type.find(function (it) {
                    return it.id + '' === _this2.detailData.business_type + '';
                  });

                  _this2.detailData.business_type_txt = _.get(businessTypeObj, 'title', '');

                case 17:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    setTagDetail: function setTagDetail(source) {
      var tag = [];
      var labelTag = [];
      var otherTag = [];
      var tagFirstLetter = '';
      for (var i = 0; i < source.length; i++) {
        tagFirstLetter = source[i].substr(0, 1);
        if (tagFirstLetter === 'A') {
          tag.push(source[i]);
        } else if (tagFirstLetter === 'B') {
          labelTag.push(source[i]);
        } else {
          otherTag.push(source[i]);
        }
      }
      this.detailData.tag = tag;
      this.detailData.label_tag = labelTag;
      this.detailData.other_tag = otherTag;
    },
    getValue: function getValue(scope, name) {
      return this.detailData[scope.row.key][name];
    },
    filterImgUrl: function filterImgUrl(url) {
      var suffix = '';
      if (url.indexOf('?x-oss-process') === -1) {
        suffix = '?x-oss-process=image/resize,w_200/auto-orient,1';
      }
      return filter.ossHost(url, suffix);
    },
    onPreviewVideo: function onPreviewVideo(url) {
      var _this3 = this;

      // 构造所有视频 URL 列表，并计算当前点击视频的索引，交给 VideoPlayerDialog 播放
      var videoList = (this.detailData.workcard_photo || []).filter(function (photo) {
        return _this3.isVideoFile(photo);
      });
      this.videoPreviewVideos = videoList;
      this.videoPreviewIndex = Math.max(videoList.indexOf(url), 0);
      this.videoPreviewVisible = true;
    }
  })
});

/***/ }),

/***/ 5779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-row',{staticClass:"sj-container"},[_c('el-table',{attrs:{"highlight-current-row":true,"data":_vm.table,"show-header":false,"border":""}},[_c('el-table-column',{attrs:{"width":"150","prop":"label"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.detailData[scope.row.key] || _vm.detailData[scope.row.key] === 0 )?_c('span',[(_vm.detailData[scope.row.key].constructor === String)?_c('span',[_vm._v(_vm._s(_vm.detailData[scope.row.key]))]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'userid') || _vm.ifKey(scope, 'posts') || _vm.ifKey(scope, 'comments'))?_c('span',[_vm._v("\n              "+_vm._s(_vm.detailData[scope.row.key])+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'currentstatus') || _vm.ifKey(scope, 'level') || _vm.ifKey(scope, 'type') || _vm.ifKey(scope, 'believable') || _vm.ifKey(scope, 'is_forbidden_withdraw'))?_c('span',_vm._l((_vm.userOptions[scope.row.key]),function(value){return _c('span',[(value.id === _vm.detailData[scope.row.key])?_c('span',[_vm._v(_vm._s(value.keyword))]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'status'))?_c('span',[_vm._l((_vm.freezeOptions),function(value){return _c('span',[(value.id === _vm.detailData[scope.row.key])?_c('span',[_vm._v(_vm._s(value.keyword))]):_vm._e()])}),_vm._v("\n                    \n              ")],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'freeze_reason'))?_c('span',[(_vm.detailData[scope.row.key] === 99)?_c('span',[_vm._v(_vm._s(_vm.detailData['freeze_reason_customize']))]):_vm._l((_vm.userOptions[scope.row.key]),function(value){return _c('span',[(value.id === _vm.detailData[scope.row.key])?_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v(_vm._s(value.keyword))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'tag') || _vm.ifKey(scope, 'label_tag') ||  _vm.ifKey(scope, 'teke_tag') || _vm.ifKey(scope, 'ability_group') || _vm.ifKey(scope, 'other_tag'))?_c('span',_vm._l((_vm.detailData[scope.row.key]),function(value){return _c('span',[_c('el-tag',[_vm._v(_vm._s(value))]),_vm._v("    \n              ")],1)}),0):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'occupations'))?_c('span',_vm._l((_vm.detailData.occupations),function(value){return _c('span',[_c('el-tag',[_vm._v(_vm._s(value.name))]),_vm._v("    \n            ")],1)}),0):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'weixin_info') && _vm.detailData.weixin_info)?_c('span',[_vm._v("\n            "+_vm._s(_vm.detailData.weixin_info.nickname)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'workcard_photo'))?_c('span',{staticStyle:{"display":"flex","flex-wrap":"wrap"}},[_vm._l((_vm.detailData.workcard_photo),function(url,index){return [(_vm.isVideoFile(url))?_c('video',{key:'video-' + index,staticStyle:{"width":"100px","height":"100px","object-fit":"cover","margin-right":"8px","flex-shrink":"0","position":"relative","cursor":"pointer","background-color":"#a9a5a5ff"},attrs:{"src":url,"preload":"metadata"},on:{"click":function($event){return _vm.onPreviewVideo(url)}}}):_c('el-image',{key:'img-' + index,staticStyle:{"width":"100px","height":"100px","object-fit":"cover","margin-right":"8px","flex-shrink":"0"},attrs:{"src":url,"preview-src-list":_vm.detailData.workcard_photo.filter(function (u) { return !_vm.isVideoFile(u); })}})]})],2):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'workinfo_status'))?_c('span',[_vm._l((_vm.options.workinfoStatus),function(item){return (parseInt(item.value) === parseInt(_vm.detailData.workinfo_status))?[_c('span',[_vm._v(_vm._s(item.label))])]:_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'current_location'))?_c('span',[_c('div',[_vm._v(_vm._s(_vm.getValue(scope,'user'))+"     (心跳)")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.getValue(scope,'system'))+"     (工单)")])]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'current_market_system'))?_c('span',[_c('div',[_vm._v(_vm._s(_vm.detailData.current_market.system))])]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'user_watched_market'))?_c('span',[_vm._v("\n            "+_vm._s(_vm.detailData.user_watched_market.map(function (m) { return m.marketname + '/' + m.id; }).join('， '))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'user_watched_locations'))?_c('span',[_vm._l((_vm.detailData.user_watched_locations),function(location){return [_c('div',[_vm._v(_vm._s(location.location_name)+"："+_vm._s(location.location_address)+"，周边"+_vm._s(location.distance)+" km")])]})],2):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'order_list'))?_c('span',[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/order/table?userid='+_vm.id,"target":"_blank"}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("订单列表")])]),_vm._v("    \n\n              "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{path: '/users/amount?userid='+_vm.id}}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("赏金明细")])]),_vm._v("    \n              "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{path: '/users/point?userid='+_vm.id}}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("积分明细")])])],1):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'archieve_tasks_list'))?_c('span',[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.base+'/index.php?action=es_task&isoffline=1&userid='+_vm.detailData['userid'],"target":"_blank"}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("归档任务列表页")])])]):_vm._e()]}}])})],1)],1),_vm._v(" "),_c('video-player-dialog',{attrs:{"visible":_vm.videoPreviewVisible,"videos":_vm.videoPreviewVideos,"index":_vm.videoPreviewIndex},on:{"update:visible":function($event){_vm.videoPreviewVisible=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-info.1095a54ed3a8e829c4f0.js